import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6 p-md-6" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-col-6 p-md-6" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"12px"} }, "Biểu đồ thống kê chỉ đạo trong 12 tháng theo hợp đồng ", -1)
const _hoisted_7 = { class: "card" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"12px"} }, "Biểu đồ thống kê chỉ đạo trong 12 tháng đến các bệnh viện", -1)
const _hoisted_9 = { class: "p-col-6 p-md-6" }
const _hoisted_10 = {
  class: "card",
  style: {"height":"100%"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"12px"} }, "Biểu đồ thống kê tất cả chỉ đạo", -1)
const _hoisted_12 = { class: "p-field p-col-6 p-md-6" }
const _hoisted_13 = {
  class: "card",
  style: {"height":"100%"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"12px"} }, "Biểu đồ thống kê tất cả chỉ đạo trong 12 tháng", -1)
const _hoisted_15 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_16 = { class: "p-field p-col-4 p-md-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Từ tháng", -1)
const _hoisted_18 = { class: "p-field p-col-4 p-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Đến tháng", -1)
const _hoisted_20 = { class: "p-field p-col-4 p-md-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Thống kê", -1)
const _hoisted_22 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "Thống kê chỉ đạo tuyến " }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_Chart, {
                    type: "line",
                    data: $setup.totalDataContact,
                    options: _ctx.basicOptions
                  }, null, 8, ["data", "options"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Chart, {
                    type: "line",
                    data: $setup.totalData,
                    options: _ctx.basicOptions
                  }, null, 8, ["data", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Chart, {
                    type: "pie",
                    data: $setup.totalDataWithPie,
                    options: _ctx.lightOptions
                  }, null, 8, ["data", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Chart, {
                type: "bar",
                data: $setup.slackedData,
                options: $setup.horizontalOptions
              }, null, 8, ["data", "options"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { header: "Thống kê chi tiết trong khoản thời gian" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_Calendar, {
              id: "monthSelect",
              modelValue: $setup.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
              view: "month",
              dateFormat: "mm/yy",
              yearRange: "2000:2100",
              showButtonBar: false,
              showIcon: true,
              manualInput: false
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_Calendar, {
              id: "monthSelect2",
              modelValue: $setup.date2,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.date2) = $event)),
              view: "month",
              dateFormat: "mm/yy",
              yearRange: "2000:2100",
              showButtonBar: false,
              showIcon: true,
              manualInput: false
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_Button, {
              label: "Thống kê giữa các loại chuyển giao",
              icon: "pi pi-chart-line",
              iconPos: "left",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.selectCalendar()))
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_Dialog, {
        header: "Biểu đồ thống kê chỉ đạo",
        visible: $setup.showStatistical,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.showStatistical) = $event)),
        style: {"width":"70em"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Chart, {
            type: "line",
            data: $setup.totalListData,
            options: _ctx.basicOptions
          }, null, 8, ["data", "options"])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}